/**
 * Атмосфера — воздух приложения.
 *
 * Монтируется один раз в корне и дальше не участвует ни в чём: ни пропсов,
 * ни состояния, ни перерисовок. Два фиксированных слоя, между которыми
 * живёт весь интерфейс:
 *
 *   позади  — туман и виньетка (глубина)
 *   поверх  — зерно (общая плёнка)
 *
 * Почему одним компонентом, а не двумя. Зерно без тумана выглядит грязью
 * на плоской заливке, туман без зерна — стоковым градиентом. Работает
 * только пара, поэтому взять половину нельзя даже случайно.
 *
 * Стили — глобальные (material.css), а не CSS-модуль: слои существуют
 * ровно в одном экземпляре на приложение, и имена классов должны быть
 * доступны в том числе не из React — например, чтобы отрисовать атмосферу
 * в статическом HTML до загрузки бандла.
 *
 * Управление силой и деградацией — целиком в CSS и в @taro/motion.
 * Здесь нет ни одного числа.
 */

export function Atmosphere() {
  return (
    <>
      {/* aria-hidden на обоих слоях: это оформление, в дереве доступности
          его быть не должно. Скринридер не должен знать слово «туман». */}
      <div className="atmosphere" aria-hidden="true">
        <span className="atmosphere__fog atmosphere__fog--a" />
        <span className="atmosphere__fog atmosphere__fog--b" />
        <span className="atmosphere__fog atmosphere__fog--c" />
        <span className="atmosphere__vignette" />
      </div>
      <div className="grain" aria-hidden="true" />
    </>
  )
}
